/*
 * ih.user
 *
 * Stores functions for working with users
 *
 * Depends:
 *      ih 
 *
 */
//    console.log("authenticatedUser", ih.authenticatedUser);   

    ih = ih || {}; 
    ih.user = ih.user || {}; 


    ih.user.authenticatedUserIsOwnerOfAcnt = function(acnt) {
        
//        console.log('owner check', acnt, ih.authenticatedUser.websiteRoles);
        
        if(!('authenticatedUser' in ih) || !('websiteRoles' in ih.authenticatedUser)) {
            console.log("Missing authenticated user or roles object.");
            return false;
        }

        if (ih.authenticatedUser.isCSR) {
            return true;
        }
        
        if( acnt in ih.authenticatedUser.websiteRoles && 'owner' == ih.authenticatedUser.websiteRoles[acnt] ) {
            return true;
        }
        
        return false;
    };
    
    
    ih.user.authenticatedUserIsAdminOfAcnt = function(acnt) {
        
//        console.log('admin check', acnt, ih.authenticatedUser.websiteRoles);
        
        if(!('authenticatedUser' in ih) || !('websiteRoles' in ih.authenticatedUser)) {
            console.log("Missing authenticated user or roles object.");
            return false;
        }
        
        if(ih.authenticatedUser.isCSR) {
            return true;
        }
        
        if( acnt in ih.authenticatedUser.websiteRoles && 
                ('owner' == ih.authenticatedUser.websiteRoles[acnt] || 
                 'admin' == ih.authenticatedUser.websiteRoles[acnt] )  
          ) {
            return true; 
        }
        
        return false;
    };
    
    ih.user.authenticatedUserIsUserOfAcnt = function(acnt) {
        
//        console.log('user check', acnt, ih.displayedUser.websiteRoles);
        
        if(!('authenticatedUser' in ih) || !('websiteRoles' in ih.authenticatedUser)) {
            console.log("Missing authenticated user or roles object.");
            return false;
        }
        
        if(ih.authenticatedUser.isCSR) {
            return true;
        }
        
        if( acnt in ih.authenticatedUser.websiteRoles  ) {
            return true;
        }
        
        return false;
    };

    ih.user.displayedUserIsOwnerOfAcnt = function(acnt) {

           console.log('owner check', acnt, ih.displayedUser.websiteRoles);

        if(!('displayedUser' in ih) || !('websiteRoles' in ih.displayedUser)) {
            console.log("Missing displayed user or roles object.");
            return false;
        }

        if( acnt in ih.displayedUser.websiteRoles && 'owner' == ih.displayedUser.websiteRoles[acnt] ) {
            return true;
        }

        return false;
    };

    ih.user.displayedUserIsAdminOfAcnt = function(acnt) {

           console.log('admin check', acnt, ih.authenticatedUser.websiteRoles);

        if(!('displayedUser' in ih) || !('websiteRoles' in ih.displayedUser)) {
            console.log("Missing displayed user or roles object.");
            return false;
        }

        if( acnt in ih.displayedUser.websiteRoles &&
            ('owner' == ih.displayedUser.websiteRoles[acnt] ||
                'admin' == ih.displayedUser.websiteRoles[acnt] )
        ) {
            return true;
        }

        return false;
    };

    ih.user.displayedUserIsUserOfAcnt = function(acnt) {

           console.log('user check', acnt, ih.displayedUser.websiteRoles);

        if(!('displayedUser' in ih) || !('websiteRoles' in ih.authenticatedUser)) {
            console.log("Missing displayed user or roles object.");
            return false;
        }

        if( acnt in ih.displayedUser.websiteRoles  ) {
            return true;
        }

        return false;
    };

